(() => {
  if (customElements.get('pp-atc-price')) return;

  class PPAtcPrice extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.m-main-product');
      this.form = this.closest('form');
      this.button = this.closest('button');
      this.amount = this.querySelector('[data-atc-price-amount]');
      if (!this.section || !this.form || !this.button || !this.amount) return;

      try {
        this.product = JSON.parse(this.section.querySelector('#productData').textContent);
      } catch (_) {
        this.hidden = true;
        return;
      }

      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.scheduleUpdate = () => {
        if (this.updateQueued) return;
        this.updateQueued = true;
        queueMicrotask(() => {
          this.updateQueued = false;
          if (this.isConnected) this.update();
        });
      };
      this.section.addEventListener('input', this.scheduleUpdate, options);
      this.section.addEventListener('change', this.scheduleUpdate, options);

      // Native variant handling rewrites the adjacent label, never this price.
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => !this.contains(record.target))) this.scheduleUpdate();
      });
      this.observer.observe(this.button, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
      if (window.MinimogEvents?.subscribe) {
        this.unsubscribe = window.MinimogEvents.subscribe(
          `${this.product.id}__VARIANT_CHANGE`,
          this.scheduleUpdate
        );
      }
      this.update();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.unsubscribe?.();
    }

    quantity(input) {
      if (!input) return 1;
      const value = Number(input.value);
      return Number.isSafeInteger(value) && value > 0 && input.checkValidity() ? value : null;
    }

    update() {
      const id = this.form.elements.namedItem('id')?.value;
      const variant = this.product.variants.find((item) => String(item.id) === id);
      const quantity = this.quantity(this.form.elements.namedItem('quantity'));
      const label = this.button.querySelector('.m-add-to-cart--text')?.textContent.trim();
      const expectedLabel = this.button.dataset.atcText || window.MinimogStrings?.addToCart;
      const mainForm = this.section.querySelector('.m-product-form--main form');
      const sellingPlan = mainForm?.elements.namedItem('selling_plan')?.value;
      let unitPrice = variant?.price;

      if (sellingPlan) {
        unitPrice = variant?.selling_plan_allocations?.find(
          (allocation) => String(allocation.selling_plan_id) === sellingPlan
        )?.price;
      }
      if (!variant?.available || quantity === null || !Number.isSafeInteger(unitPrice) ||
          (expectedLabel && label !== expectedLabel.trim())) {
        this.hidden = true;
        return;
      }

      let total = unitPrice * quantity;
      for (const row of this.section.querySelectorAll('[data-addon-row]')) {
        const check = row.querySelector('[data-addon-check]');
        if (!check?.checked || check.disabled) continue;
        const option = row.querySelector('[data-addon-variant]')?.selectedOptions[0];
        const addonQuantity = this.quantity(row.querySelector('[data-addon-quantity]'));
        const price = Number(option?.dataset.priceCents);
        if (!option || option.disabled || option.dataset.available !== 'true' ||
            addonQuantity === null || !Number.isSafeInteger(price)) {
          this.hidden = true;
          return;
        }
        total += price * addonQuantity;
      }
      if (!Number.isSafeInteger(total) || total < 0) {
        this.hidden = true;
        return;
      }

      try {
        const text = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: this.dataset.currency || 'INR',
          minimumFractionDigits: total % 100 === 0 ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(total / 100);
        if (this.amount.textContent !== text) this.amount.textContent = text;
        this.hidden = false;
      } catch (_) {
        this.hidden = true;
      }
    }
  }

  customElements.define('pp-atc-price', PPAtcPrice);
})();
